/** Mount/cleanup are outside-system work; React Query owns evaluation transport and its cancellable typing delay. */
import { useEffect, useLayoutEffect, useRef } from 'react'
export function useBuilderEvaluationWork(start: () => void, stop: () => void) {
  useEffect(() => {
    start()
    return stop
  }, [start, stop])
}

/** Keep event callbacks on committed inputs without accessing a ref during render. */
export function useBuilderEvaluationInput<T>(value: T) {
  const latest = useRef(value)
  useLayoutEffect(() => {
    latest.current = value
  }, [value])
  return latest
}
